// 생성 파일 — 손으로 고치지 않는다. 원문 `tools/policy-sources/terms-2026-09-22.ko.txt`, 변환 `tools/make-policy-docs.py`.
import type { PolicyDoc } from '../../policyDoc';

export const terms20260922Ko: PolicyDoc = {
  title: '서비스 이용약관',
  articles: [
    {
      title: '제1조 (목적)',
      blocks: [
        {
          type: 'p',
          text: '이 약관은 뮤즐리(이하 "회사")가 제공하는 보컬 진단 서비스 MUZLY(이하 "서비스")의 이용 조건과 절차, 회사와 이용자의 권리·의무 및 책임 사항을 정합니다.',
        },
      ],
    },
    {
      title: '제2조 (정의)',
      blocks: [
        {
          type: 'p',
          text: '1. "서비스"란 이용자의 음성을 녹음·분석해 음역·음정·호흡·음색 등의 지표와 진단 결과를 제공하는 앱과 웹의 기능 일체를 말합니다.',
        },
        {
          type: 'p',
          text: '2. "이용자"란 이 약관에 따라 서비스를 이용하는 사람을 말합니다.',
        },
        {
          type: 'p',
          text: '3. "녹음 데이터"란 이용자가 진단을 위해 서비스에서 녹음한 음성과 그 분석 결과를 말합니다.',
        },
      ],
    },
    {
      title: '제3조 (약관의 게시와 개정)',
      blocks: [
        {
          type: 'p',
          text: '1. 회사는 이 약관을 서비스 화면에 게시합니다.',
        },
        {
          type: 'p',
          text: '2. 회사는 관련 법령을 위반하지 않는 범위에서 약관을 개정할 수 있으며, 개정하면 시행일 7일 전부터 서비스 화면에 알립니다. 이용자에게 불리한 개정은 30일 전부터 알립니다.',
        },
        {
          type: 'p',
          text: '3. 이용자가 개정 약관의 시행일 이후에도 서비스를 계속 이용하면 개정 약관에 동의한 것으로 봅니다. 동의하지 않는 이용자는 이용을 중단할 수 있습니다.',
        },
      ],
    },
    {
      title: '제4조 (이용 계약)',
      blocks: [
        {
          type: 'p',
          text: '이용 계약은 이용자가 서비스를 설치하거나 접속해 이 약관에 동의하고 이용을 시작한 때 성립합니다. 서비스는 별도의 회원 가입 없이 이용할 수 있습니다.',
        },
      ],
    },
    {
      title: '제5조 (서비스의 제공과 변경)',
      blocks: [
        {
          type: 'p',
          text: '1. 회사는 보컬 진단, 진단 결과와 회차별 변화 조회, 그 밖에 회사가 정하는 기능을 무료로 제공합니다.',
        },
        {
          type: 'p',
          text: '2. 회사는 운영·기술상 필요에 따라 서비스의 내용을 변경할 수 있으며, 중요한 변경은 서비스 화면에 미리 알립니다.',
        },
      ],
    },
    {
      title: '제6조 (서비스의 중단)',
      blocks: [
        {
          type: 'p',
          text: '회사는 설비 점검·교체, 장애, 통신 두절, 천재지변 등 부득이한 사유가 있으면 서비스를 일시 중단할 수 있습니다. 사업상 이유로 서비스를 종료할 때는 30일 전부터 서비스 화면에 알립니다.',
        },
      ],
    },
    {
      title: '제7조 (진단 결과의 성격)',
      blocks: [
        {
          type: 'p',
          text: '1. 서비스의 진단 결과는 녹음된 음성을 자동으로 분석한 참고 정보이며, 의학적 진단·치료나 전문가의 평가를 대신하지 않습니다.',
        },
        {
          type: 'p',
          text: '2. 결과는 기기, 마이크, 주변 소음, 목 상태 등 녹음 환경에 따라 달라질 수 있습니다.',
        },
        {
          type: 'p',
          text: '3. 목소리나 발성 기관에 이상이 느껴지면 의료 전문가와 상담하시기 바랍니다.',
        },
      ],
    },
    {
      title: '제8조 (녹음 데이터와 권리)',
      blocks: [
        {
          type: 'p',
          text: '1. 녹음 데이터에 대한 권리는 이용자에게 있습니다.',
        },
        {
          type: 'p',
          text: '2. 이용자는 회사가 진단 결과 제공, 결과 재생, 서비스 품질과 분석 정확도 개선을 위해 녹음 데이터를 저장·분석하는 것에 동의합니다. 회사는 이 목적 밖으로 녹음 데이터를 이용하거나 제3자에게 제공하지 않습니다.',
        },
        {
          type: 'p',
          text: '3. 서비스에 대한 저작권과 그 밖의 지식재산권은 회사에 있습니다.',
        },
      ],
    },
    {
      title: '제9조 (개인정보 보호)',
      blocks: [
        {
          type: 'p',
          text: '회사는 관련 법령에 따라 이용자의 개인정보를 보호하며, 개인정보의 수집·이용·보관·파기에 관한 사항은 개인정보처리방침에 따릅니다.',
        },
      ],
    },
    {
      title: '제10조 (이용자의 의무)',
      blocks: [
        {
          type: 'p',
          text: '이용자는 다음 행위를 해서는 안 됩니다.',
        },
        {
          type: 'p',
          text: '1. 타인의 음성을 동의 없이 녹음해 진단하는 행위',
        },
        {
          type: 'p',
          text: '2. 서비스를 역설계·복제·변경하거나 정상적인 운영을 방해하는 행위',
        },
        {
          type: 'p',
          text: '3. 관련 법령이나 이 약관을 위반하는 행위',
        },
      ],
    },
    {
      title: '제11조 (이용 제한과 해지)',
      blocks: [
        {
          type: 'p',
          text: '1. 이용자는 언제든지 앱을 삭제해 이용을 종료할 수 있으며, 서버에 보관된 녹음 데이터와 프로필의 삭제를 support@muzly.io 로 요청할 수 있습니다.',
        },
        {
          type: 'p',
          text: '2. 회사는 이용자가 제10조를 위반하면 서비스 이용을 제한할 수 있습니다.',
        },
      ],
    },
    {
      title: '제12조 (책임의 제한)',
      blocks: [
        {
          type: 'p',
          text: '1. 회사는 천재지변 등 불가항력이나 이용자의 귀책 사유로 생긴 손해에 대해 책임지지 않습니다.',
        },
        {
          type: 'p',
          text: '2. 회사는 진단 결과를 참고해 이용자가 내린 판단과 그 결과에 대해 회사의 고의 또는 중대한 과실이 없는 한 책임지지 않습니다.',
        },
        {
          type: 'p',
          text: '3. 서비스는 무료로 제공되며, 회사는 관련 법령이 허용하는 범위에서 무료 서비스 이용으로 생긴 손해에 대해 책임지지 않습니다.',
        },
      ],
    },
    {
      title: '제13조 (문의)',
      blocks: [
        {
          type: 'p',
          text: '서비스와 약관에 관한 문의는 support@muzly.io 로 보낼 수 있습니다.',
        },
      ],
    },
    {
      title: '제14조 (준거법과 관할)',
      blocks: [
        {
          type: 'p',
          text: '이 약관은 대한민국 법률에 따라 해석되며, 서비스 이용과 관련한 분쟁은 민사소송법에 따른 관할 법원에서 해결합니다.',
        },
      ],
    },
    {
      title: '부칙',
      blocks: [
        {
          type: 'p',
          text: '이 약관은 2026년 9월 22일부터 시행합니다.',
        },
      ],
    },
  ],
};
